import classNames from 'classnames'
import { useTranslation } from 'next-i18next/pages'
import SignatureCanvas from 'react-signature-canvas'
import styles from './SignatureSection.module.scss'
import { SignatureSectionProps } from './types'
import { Button, FormFieldLayout } from '@boltenergy-be/design-system'

const SignatureSection = ({ clearSignature, setValue, signatureRef, signatureError }: SignatureSectionProps) => {
  //i18n
  const { t } = useTranslation(['registration', 'validation'])

  return (
    <section>
      <FormFieldLayout
        description={t('overview.signature.description')}
        error={signatureError ? t('validation:required') : undefined}
        label={t('overview.signature.title')}
        labelComponentSlot={
          <Button variant="inline" onClick={() => clearSignature()}>
            {t('overview.signature.reset')}
          </Button>
        }
      >
        <SignatureCanvas
          canvasProps={{ className: classNames(styles['signature-canvas']) }}
          clearOnResize={false}
          ref={signatureRef}
          onEnd={() => {
            setValue('signature', signatureRef.current.toDataURL(), { shouldValidate: true })
          }}
        />
      </FormFieldLayout>
    </section>
  )
}

export default SignatureSection
